import React from 'react';
import { IonButton, IonFooter, IonProgressBar } from '@ionic/react';

import '../../../styles/fight/takerProcess/TakerModalFooter.scss';

function TakerModalFooter({ buttonName, isDisabled, onClick, ComponentAboveButton }) {
  return (
    <IonFooter className='taker-modal-footer ion-no-border'>
      {ComponentAboveButton && <ComponentAboveButton />}
      <div className='ion-padding'>
        <IonButton className='next-button' expand='block' onClick={onClick} disabled={isDisabled}>
          <p>{buttonName}</p>
        </IonButton>
      </div>
      <IonProgressBar className='progress-bar' value={1} />
    </IonFooter>
  );
}

export default TakerModalFooter;
